import { safeGetProjectName } from '../utils';
export const connectionSpecToClientMetadata = ({
  appName,
  tags = [],
  portalId
}) => ({
  portalId: portalId === null || portalId === void 0 ? void 0 : portalId.toString(),
  appName: appName || safeGetProjectName() || 'unknown',
  tags
});